module.exports = __webpack_public_path__ + "img/estimate_banner.4efbe917.png";